import * as url from "url"
import { FetchArgs, ListResult, ModelResult, PagedListResult, QueryAsset, DeleteAsset, CreateAssetArea, UpdateAsset, AssetArea, AssetCategory, Facility, Asset, CreateAsset, Dict, QueryAssetLoan, CreateAssetCategory, UpdateAssetCategory, UpdateAssetArea, AppCodeResult, CarrierResult, AssetLoan, UpdateAssetLoan, CreateAssetLoan, AssetLoanHistory, FileUpload, LoanHistorySummary, Tablet, GetTablet } from "./model"
import { get } from "https"
import { inspect } from "util";
import { sortByDate, convertToMultiMap, copyProperties } from "../utils/core";
import { UiUtils } from "../ui/ui";


export interface FetchArgsHelper {
    getArgs(params?: any): FetchArgs
    deleteArgs(params?: any): FetchArgs
    postArgs(params?: any): FetchArgs
    postJsonArgs(json: any): FetchArgs
    putJsonArgs(json: any, params?: any): FetchArgs
}

export abstract class FetchArgsBase implements FetchArgsHelper {
    protected abstract createUrl(params?: any): string
    protected abstract defaultOptions?: any
    protected abstract options?: any

    protected static isLocal(): boolean {
        return location.hostname == "localhost"
    }

    getArgs(params?: any): FetchArgs {
        return {
            url: this.createUrl(params),
            options: this.getOptions()
        }
    }

    deleteArgs(params?: any): FetchArgs {
        return {
            url: this.createUrl(params),
            options: this.deleteOptions()
        }
    }

    postArgs(params?: any): FetchArgs {
        return {
            url: this.createUrl(params),
            options: this.postOptions()
        }
    }

    postJsonArgs(json: any = {}): FetchArgs {
        return {
            url: this.createUrl(),
            options: this.postJsonOptions(json)
        }
    }

    putJsonArgs(json: any = {}, params?: any): FetchArgs {
        return {
            url: this.createUrl(params),
            options: this.putJsonOptions(json)
        }
    }

    private getOptions(): RequestInit {
        return Object.assign({}, {
            method: "GET"
        }, this.defaultOptions, this.options)
    }

    private postOptions(): RequestInit {
        return Object.assign({}, {
            method: "POST"
        }, this.defaultOptions, this.options)
    }

    private putOptions(): RequestInit {
        return Object.assign({}, {
            method: "PUT"
        }, this.defaultOptions, this.options)
    }

    private deleteOptions(): RequestInit {
        return Object.assign({}, {
            method: "DELETE"
        }, this.defaultOptions, this.options)
    }

    private postJsonOptions(json: any = {}) {
        const options = this.postOptions()
        options.body = JSON.stringify(json)
        options.headers = Object.assign({}, {
            "Content-Type": "application/json"
        }, options.headers)
        return options
    }

    private putJsonOptions(json: any = {}) {
        const options = this.putOptions()
        options.body = JSON.stringify(json)
        options.headers = Object.assign({}, {
            "Content-Type": "application/json"
        }, options.headers)
        return options
    }

    protected static getCurrentUrlBase(): string {
        return `${location.protocol}//${location.host}`
    }

}

export class HouseKeeperFetchArgsBase extends FetchArgsBase {
    private static local = HouseKeeperFetchArgsBase.isLocal()
    private static baseUrl = HouseKeeperFetchArgsBase.getCurrentUrlBase()
    protected defaultOptions = HouseKeeperFetchArgsBase.getDefaultOptions()

    constructor(private basePath: string, protected options?: any) {
        super()
    }

    private static getDefaultOptions(): any {
        var opts: any = {
            credentials: 'include'
        }
        return opts
    }

    createUrl(params?: any): string {
        const urlObj = url.parse(HouseKeeperFetchArgsBase.baseUrl + this.basePath, true)
        urlObj.query = Object.assign({}, urlObj.query, params)
        return url.format(urlObj)
    }
}

export class AssetFetchArgsBase extends FetchArgsBase {
    private static local = AssetFetchArgsBase.isLocal()
    private static apiVersion = '1.0'
    protected defaultOptions = AssetFetchArgsBase.getDefaultOptions()

    constructor(private basePath: string, private baseUrl?: string, protected options?: any) {
        super()
        if (baseUrl == null) {
            this.baseUrl = AssetFetchArgsBase.getApiBaseUrl()
        }
    }

    private static getDefaultOptions(): any {
        var opts: any = {
            credentials: 'include'
        }
        if (AssetFetchArgsBase.local) {
            opts.mode = 'cors'
        }
        return opts
    }

    private static getApiBaseUrl(): string {
        if (AssetFetchArgsBase.local) {
            return this.getCurrentUrlBase() + '/KingNetApiMvc'
        } else {
            return this.getCurrentUrlBase() + '/KingNetApiMvc'
        }
    }

    createUrl(params?: any): string {
        const urlObj = url.parse(this.baseUrl + this.basePath, true)
        urlObj.query = Object.assign({}, urlObj.query, {
            "api-version": AssetFetchArgsBase.apiVersion,
        }, params)
        return url.format(urlObj)
    }
}

export class RestfulError extends Error {
    constructor(public statusCode: number, public errorCode: number, public errorMessage: string) {
        super()
    }

    isClientError() {
        return this.statusCode < 500;
    }
}

export class ApiBase {
    constructor(protected fetchArgsHelper: FetchArgsHelper) {
    }

    protected async fetch(input: RequestInfo, init?: RequestInit, silentAlert?: boolean) {
        try {
            const resp = await fetch(input, init)
            console.log("API resp:%s", resp.status)
            if (resp.status >= 200 && resp.status < 300) {
               
                const json = resp.json()
                return json
            } else {
                if (resp.headers.get('Content-Type').startsWith('application/json')) {
                    const json = await resp.json()
                    throw new RestfulError(resp.status, json['errorCode'], json['errorMessage'])
                } else {
                    const body = await resp.text()
                    throw new RestfulError(500, Number(resp.status.toString() + '999'), "Status:" + resp.status + " - Body:\n" + body)
                }

                //const json = resp.json()
                //const body = await resp.text()
                //console.log("Response body:%s", body)
            }
        } catch (e) {
            if (!(e instanceof RestfulError)) {
                if (silentAlert != true) {
                    UiUtils.alert("遠端請求非預期錯誤，請稍後再試！")
                }
                console.error("Fetch error - input:\n%s - init:\n%s - error:\n%s", inspect(input, false, 5), inspect(init, false, 5), e)
            } else {
                if (e.statusCode >= 500) {
                    if (silentAlert != true) {
                        UiUtils.alert(`遠端請求非預期錯誤，錯誤碼:${e.errorCode} 請稍後再試！`)
                    }
                    console.error("Fetch error - input:\n%s - init:\n%s - error:\n%s", inspect(input, false, 5), inspect(init, false, 5), inspect(e, false, 5))
                }
            }
            throw e
        }
    }

    protected getArgs(params?: any): FetchArgs {
        return this.fetchArgsHelper.getArgs(params)
    }

    protected deleteArgs(params?: any): FetchArgs {
        return this.fetchArgsHelper.deleteArgs(params)
    }

    protected postJsonArgs(json: any = {}): FetchArgs {
        return this.fetchArgsHelper.postJsonArgs(json)
    }

    protected putJsonArgs(json: any = {}, params?: any): FetchArgs {
        return this.fetchArgsHelper.putJsonArgs(json, params)
    }

    protected postArgs(params?: any): FetchArgs {
        return this.fetchArgsHelper.postArgs(params)
    }
}

export interface AssetLoanHistoryLine {
    loanId: string
    loanDate: Date
    tabletId: string
    guestId: string
    quantity: number
    returnDate?: Date
    allReturnDate?: Date
    returnQuantity: number
    needReturnQuantity: number
    sortDate: Date
}
export interface AssetLoanHistoryLines {
    linesMapByAsset: Dict<Array<AssetLoanHistoryLine>>
    tabletsMap: Dict<Tablet>
}

export class AssetLoanApi extends ApiBase {
    constructor(baseUrl?: string, options?: any) {
        super(new AssetFetchArgsBase('/asset_loans', baseUrl, options))
    }

    private static async createAssetLoanHistoryLines(loans: Array<AssetLoan>, expectedAssets: Array<Number>, tabletApi: TabletApi): Promise<AssetLoanHistoryLines> {

        const linesMapByAsset: Dict<Array<AssetLoanHistoryLine>> = {}
        const tabletsMap: Dict<Tablet> = {}
        const tabletIds: Array<string> = []
        
        const result: AssetLoanHistoryLines = {
            linesMapByAsset: linesMapByAsset,
            tabletsMap: tabletsMap
        }

        expectedAssets.forEach(assetId => {
            const lines: Array<AssetLoanHistoryLine> = loans.map(loan => {
                const loanHistory = loan.loanHistories.find(it => it.assetId == assetId)
                if (loanHistory == null) {
                    return
                }
                //Collect tablets
                if (loan.tabletId != null && tabletIds.indexOf(loan.tabletId) == -1) {
                    tabletIds.push(loan.tabletId)
                }
                //Init default line base
                const returnHistories: Array<AssetLoanHistory> = sortByDate(loan.returnHistories.filter(it => it.assetId == assetId), 'createdAt', true)
                const returnQuantity = returnHistories.length > 0 ? returnHistories.map(it => it.quantity).reduce((x, y) => x + y) : 0
                const line: AssetLoanHistoryLine = {
                    loanId: loan.id,
                    loanDate: loanHistory.createdAt,
                    tabletId: loan.tabletId,
                    guestId: loan.guestId,
                    quantity: loanHistory.quantity,
                    returnQuantity: returnQuantity,
                    sortDate: loanHistory.createdAt,
                    needReturnQuantity: loanHistory.quantity
                }
                if (returnQuantity != 0) {
                    line.sortDate = returnHistories[0].createdAt
                    line.needReturnQuantity = line.quantity - returnQuantity
                    if (line.needReturnQuantity == 0) {
                        line.allReturnDate = returnHistories[0].createdAt
                    }
                }
                return line
            }).filter(it => it != null)
            linesMapByAsset[assetId.toString()] = sortByDate(lines, 'sortDate', true)
        })

        if (tabletIds.length > 0) {
  
            const tabletId2: GetTablet = {
                Ids : tabletIds
            }

            const tablets = (await tabletApi.get(tabletId2)).data
            tablets.forEach(tablet => tabletsMap[tablet.id] = tablet)
        }
        return result
    }

    private static async createLoanHistorySummary(listResult: ListResult<AssetLoan>, assetApi: AssetApi): Promise<LoanHistorySummary> {
        const assetIds: Array<any> = []
        const stillLoanHistories: Array<AssetLoanHistory> = []
        listResult.data.forEach(loan => {
            //Sorted by createdAt desc
            const loanHistories = sortByDate(loan.loanHistories, 'createdAt', true)
            const returnHistories = loan.returnHistories
            //const returnHistories = this.sortByDate(loan.returnHistories, 'createdAt')
            const loanHistoryMap = convertToMultiMap(loanHistories, 'assetId')
            const returnHistoryMap = convertToMultiMap(returnHistories, 'assetId')
            Object.keys(loanHistoryMap).forEach(assetId => {
                const loanList = loanHistoryMap[assetId] //Copy new one
                const returnList = returnHistoryMap[assetId]
                loanList.forEach(hist => {
                    hist.loanId = loan.id
                })
                if (returnList == null) { //No any return, just add all loans
                    assetIds.push(assetId)
                    stillLoanHistories.push(...loanList)
                } else {
                    const totalLoanCount = loanList.map(it => it.quantity).reduce((x, y) => x + y)
                    const totalReturnCount = returnList.map(it => it.quantity).reduce((x, y) => x + y)
                    let stillLoanCount = totalLoanCount - totalReturnCount
                    if (stillLoanCount > 0) {
                        assetIds.push(assetId)
                        const loanListToAdd = loanList.map(hist => {
                            const newHist: AssetLoanHistory = copyProperties(hist)
                            if (newHist.quantity < stillLoanCount) {
                                stillLoanCount -= newHist.quantity
                            } else {
                                newHist.quantity = stillLoanCount
                                stillLoanCount = 0
                            }
                            return newHist
                        }).filter(hist => hist.quantity > 0)
                        console.log("Loan list to add:%s", loanListToAdd.length)
                        stillLoanHistories.push(...loanListToAdd)
                    }
                }
            })
            loanHistories.forEach(hist => {
                console.log("Hist:%s", inspect(hist))
            })
            stillLoanHistories.forEach(hist => {
                console.log("Loan:%s", inspect(hist))
            })
        })
        const result: LoanHistorySummary = {
            assets: [],
            loanHistories: stillLoanHistories
        }
        if (assetIds.length > 0) {
            const assetResp = await assetApi.query({
                ids: assetIds, maxCount: assetIds.length
            })
            result.assets = assetResp.data
        }
        return result

    }

    async queryAssetLoanHistoryLines(assetIds: Array<number>, tabletApi: TabletApi): Promise<AssetLoanHistoryLines> {
        const query: QueryAssetLoan = {
            assetIds: assetIds
        }
        const loans = await this.query(query)

        if (loans.data.length != 0) {
            return AssetLoanApi.createAssetLoanHistoryLines(loans.data, assetIds, tabletApi)
        } else {
            return { linesMapByAsset: {}, tabletsMap: {} }
        }
    }

    async queryLoanHistorySummary(queryAssetLoan: QueryAssetLoan, assetApi: AssetApi): Promise<LoanHistorySummary> {
        const loans = await this.query(queryAssetLoan)
        return AssetLoanApi.createLoanHistorySummary(loans, assetApi)
    }

    async query(queryAssetLoan: QueryAssetLoan): Promise<ListResult<AssetLoan>> {
        const getArgs = this.getArgs(queryAssetLoan)
        /*
        const d = new Date().getTime()
        return new Promise<ListResult<AssetLoan>>(resolve => {
            const loans: Array<AssetLoan> = [{
                id: "Loan id1",
                loanHistories: [{
                    assetId: 67,
                    createdAt: new Date(d + 1),
                    quantity: 10,
                }, {
                    assetId: 68,
                    createdAt: new Date(d + 2),
                    quantity: 5,
                }, {
                    assetId: 3,
                    createdAt: new Date(d + 3),
                    quantity: 3,
                }],
                returnHistories: [{
                    assetId: 67,
                    createdAt: new Date(d + 2),
                    quantity: 8,
                }, {
                    assetId: 68,
                    createdAt: new Date(d + 2),
                    quantity: 1,
                }, {
                    assetId: 68,
                    createdAt: new Date(d + 3),
                    quantity: 2,
                }, {
                    assetId: 3,
                    createdAt: new Date(d + 4),
                    quantity: 3,
                }],
                createdAt: new Date(d),
                commId: "社區id"
            }]
            resolve({
                data: loans
            })
        })
        */
        return this.fetch(getArgs.url, getArgs.options)
    }

    async update(loanId: string, updateAssetLoan: UpdateAssetLoan): Promise<ModelResult<AssetLoan>> {
        const args = this.postJsonArgs(updateAssetLoan)
        args.url = args.url.replace('/asset_loans', `/asset_loans/${loanId}`)

        /*
        return new Promise<ModelResult<AssetLoan>>(resolve => {
            const loan: AssetLoan = {
                id: loan_id,
                loanHistories: [{
                    assetId: 1,
                    createdAt: new Date(),
                    quantity: 3
                }, {
                    assetId: 1,
                    createdAt: new Date(),
                    quantity: 2
                }, {
                    assetId: 2,
                    createdAt: new Date(),
                    quantity: 1
                }],
                returnHistories: [{
                    assetId: 1,
                    createdAt: new Date(),
                    quantity: 3
                }, {
                    assetId: 1,
                    createdAt: new Date(),
                    quantity: 2
                }, {
                    assetId: 2,
                    createdAt: new Date(),
                    quantity: 1
                }],
                createdAt: new Date(),
                commId: "社區id"
            }
            resolve({
                data: loan
            })
        })
        */

        return this.fetch(args.url, args.options, true)
    }

    async create(createAssetLoan: CreateAssetLoan): Promise<ModelResult<AssetLoan>> {
        console.log("Create asset:%s", inspect(createAssetLoan))
        const args = this.postJsonArgs(createAssetLoan)

        /*
        const histories = createAssetLoan.loanHistories.map(it => {
            return {
                assetId: it.assetId,
                createdAt: new Date(),
                quantity: it.quantity
            }
        })

        return new Promise<ModelResult<AssetLoan>>(resolve => {
            const loan: AssetLoan = {
                id: "Loan id 123",
                loanHistories: histories,
                returnHistories: [],
                createdAt: new Date(),
                commId: "社區id",
                signature: createAssetLoan.signature,
                picture: createAssetLoan.picture
            }
            resolve({
                data: loan
            })
        })
        */
        return this.fetch(args.url, args.options)
    }

}

export class AssetAreaApi extends ApiBase {

    constructor(baseUrl?: string, options?: any) {
        super(new AssetFetchArgsBase('/asset_areas', baseUrl, options))
    }

    async get(): Promise<ListResult<AssetArea>> {
        const getArgs = this.getArgs()
        return this.fetch(getArgs.url, getArgs.options)
    }

    async create(createAssetArea: CreateAssetArea): Promise<ModelResult<AssetArea>> {
        const postArgs = this.postJsonArgs(createAssetArea)
        return this.fetch(postArgs.url, postArgs.options)
    }

    async update(areaId: number, UpdateAssetArea: UpdateAssetArea): Promise<ModelResult<AssetCategory>> {
        const args = this.postJsonArgs(UpdateAssetArea)
        args.url = args.url.replace('/asset_areas', `/asset_areas/${areaId}`)
        return this.fetch(args.url, args.options)
    }

    async delete(areaId: number): Promise<ModelResult<any>> {
        const getArgs = this.postArgs()
        getArgs.url = getArgs.url.replace('/asset_areas', `/asset_areas/delete/${areaId}`)
        return this.fetch(getArgs.url, getArgs.options)
    }
}

function fileToFormData(file: File | Blob, fileName: string = "fileName") {
    const formData = new FormData()
    formData.append(fileName, file)
    return formData
}

export class FileApi extends ApiBase {
    constructor(baseUrl?: string, options?: any) {
        super(new AssetFetchArgsBase('/files', baseUrl, options))
    }
    private async upload(path: string, formData: FormData): Promise<ModelResult<FileUpload>> {
        const postArgs = this.postArgs()
        postArgs.url = postArgs.url.replace('/files', `/files/${path}`)
        postArgs.options['body'] = formData
        return this.fetch(postArgs.url, postArgs.options)
    }

    async uploadWebCam(file: File | Blob): Promise<ModelResult<FileUpload>> {

        return this.upload('web_cams', fileToFormData(file))
    }

    async uploadSignature(file: File | Blob): Promise<ModelResult<FileUpload>> {
        return this.upload('signatures', fileToFormData(file))
    }
}

export class AssetApi extends ApiBase {

    constructor(baseUrl?: string, options?: any) {
        super(new AssetFetchArgsBase('/assets', baseUrl, options))
    }

    async query(queryAsset: QueryAsset): Promise<PagedListResult<Asset>> {
        const getArgs = this.getArgs(queryAsset)
        return this.fetch(getArgs.url, getArgs.options)
    }

    async delete(deleteAsset: DeleteAsset): Promise<ModelResult<any>> {
        const getArgs = this.postArgs(deleteAsset)
        getArgs.url = getArgs.url.replace('/assets', '/assets/delete')
        return this.fetch(getArgs.url, getArgs.options)
    }

    async createByExcel(file: any): Promise<ListResult<Asset>> {
        const postArgs = this.postArgs()
        postArgs.url = postArgs.url.replace('/assets', '/assets/excels')
        postArgs.options['body'] = file
        return this.fetch(postArgs.url, postArgs.options)
    }

    async create(createAssets: Array<CreateAsset>): Promise<ListResult<Asset>> {
        const postArgs = this.postJsonArgs(createAssets)
        return this.fetch(postArgs.url, postArgs.options)
    }

    async update(assetId: string, updateAsset: UpdateAsset): Promise<ModelResult<Asset>> {
        const putArgs = this.postJsonArgs(updateAsset)
        putArgs.url = putArgs.url.replace('/assets', `/assets/${assetId}`)
        return this.fetch(putArgs.url, putArgs.options)
    }

    getExcelTemplateDownloadLink(): string {
        const getArgs = this.getArgs()
        return getArgs.url.replace('/assets', '/assets/excel_templates')
    }

    async CheckCategoryFinder():Promise<string> {
        console.log('CheckCategoryFinder');
        const getArgs = this.getArgs();
        getArgs.url = getArgs.url.replace('/assets', '/assets/CheckCategoryFinder');
        return this.fetch(getArgs.url, getArgs.options)
    }

    getExportToExcelLink(queryAsset: QueryAsset): string {
        const getArgs = this.getArgs(queryAsset)
        return getArgs.url.replace('/assets', '/assets/excels')
    }
}
export class HouseKeeperApi extends ApiBase {

    constructor() {
        ///ajax/ajax.asmx/checkUserCode
        super(new HouseKeeperFetchArgsBase('/ajax/ajax.asmx'))
    }

    async checkAppCode(code: string): Promise<AppCodeResult> {
        const postArgs = this.postArgs()
        postArgs.url = postArgs.url + '/checkUserCode'
        const body = new URLSearchParams()
        body.set('code', code)
        postArgs.options = Object.assign(postArgs.options, {
            body: body
        })
        return this.fetch(postArgs.url, postArgs.options)
    }

    async checkCarrier(code: string): Promise<CarrierResult> {
        const postArgs = this.postArgs()
        postArgs.url = postArgs.url + '/getCarrierTablet'
        const body = new URLSearchParams()
        body.set('val', code)
        postArgs.options = Object.assign(postArgs.options, {
            body: body
        })
        const result = await this.fetch(postArgs.url, postArgs.options)
        return {
            tablets: JSON.parse(result.list),
            status: result.status,
            total: result.total
        }
    }
}

export class AssetCategoryApi extends ApiBase {

    constructor(baseUrl?: string, options?: any) {
        super(new AssetFetchArgsBase('/asset_categories', baseUrl, options))
    }

    async get(): Promise<ListResult<AssetCategory>> {
        const getArgs = this.getArgs()
        return this.fetch(getArgs.url, getArgs.options)
    }

    async create(createAssetCategory: CreateAssetCategory): Promise<ModelResult<AssetCategory>> {
        const postArgs = this.postJsonArgs(createAssetCategory)
        return this.fetch(postArgs.url, postArgs.options)
    }

    async update(categoryId: number, UpdateAssetCategory: UpdateAssetCategory): Promise<ModelResult<AssetCategory>> {
        const args = this.postJsonArgs(UpdateAssetCategory)
        args.url = args.url.replace('/asset_categories', `/asset_categories/${categoryId}`)
        return this.fetch(args.url, args.options)
    }

    async delete(categoryId: number): Promise<ModelResult<any>> {
        const getArgs = this.postArgs()
        getArgs.url = getArgs.url.replace('/asset_categories', `/asset_categories/delete/${categoryId}`)
        return this.fetch(getArgs.url, getArgs.options)
    }
}

export class FacilityApi extends ApiBase {

    constructor(baseUrl?: string, options?: any) {
        super(new AssetFetchArgsBase('/facilities', baseUrl, options))
    }

    async get(): Promise<ListResult<Facility>> {
        const getArgs = this.getArgs()
        return this.fetch(getArgs.url, getArgs.options)
    }
}

export class TabletApi extends ApiBase {

    constructor(baseUrl?: string, options?: any) {
        super(new AssetFetchArgsBase('/tablets', baseUrl, options))
    }

    async get(ids: GetTablet): Promise<ListResult<Tablet>> {
        
        //const getArgs = this.getArgs({
           //ids: ids
        //})

        const postArgs = this.postJsonArgs(ids);

        return this.fetch(postArgs.url, postArgs.options)
        //return this.fetch(getArgs.url, getArgs.options)
    }
}